import { app } from '../../../../app';

app.component('confirmTurnOffRecovery', {
    bindings: {close: '&', dismiss: '&', resolve: '<'},
    templateUrl: require('./confirm-turn-off-recovery.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/user/phone-numbers/confirm-turn-off-recovery/confirm-turn-off-recovery.component.js